import { IsEmail, IsNotEmpty, IsString } from 'class-validator';

export class EditUserFormDTO {
  @IsString()
  @IsNotEmpty()
  public name!: string;

  @IsString()
  @IsNotEmpty()
  public firstname!: string;

  @IsString()
  @IsNotEmpty()
  public lastname!: string;

  @IsString()
  @IsEmail()
  @IsNotEmpty()
  public email!: string;
}
